export default __webpack_public_path__ + "static/media/dino@3x.35759313.png";